import { ReactNode } from "react";
import { Button, Group, Modal, Stack } from "@mantine/core";

export interface FormModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  onSubmit: () => void;
  submitLabel?: string;
  loading?: boolean;
  children: ReactNode;
  size?: string | number;
}

export function FormModal({
  opened, onClose, title, onSubmit, submitLabel = "Сохранить",
  loading, children, size = "md",
}: FormModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} size={size}>
      <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
        <Stack gap="md">
          {children}
          <Group justify="flex-end" mt="md">
            <Button variant="default" onClick={onClose} type="button" disabled={loading}>
              Отмена
            </Button>
            <Button type="submit" loading={loading}>
              {submitLabel}
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
